import useAppCtx from "../../../hooks/useAppCtx";

import loaderImg from "../../../assets/images/loader-image.png";
import Title from "../../common/Title";

import { Box, Typography } from "@mui/material";

const sx = {
  root: {
    minHeight: "calc(100vh - 138px)",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    maxWidth: "700px",
    pt: 5,
    mx: "auto",
    justifyContent: "center",
  },
  img: {
    maxWidth: "160px",
    alignSelf: "center",
  },
};

const PendingTx = () => {
  const { txEtherScan } = useAppCtx();

  return (
    <Box sx={sx.root}>
      <Box src={loaderImg} sx={sx.img} component="img"></Box>

      <Title text="Transaction In Progress" />

      <Typography variant="text" sx={{ mt: 10 }}>
        Please wait while your transaction is being processed. <br />
        {txEtherScan && (
          <>
            You can check the transaction status on{" "}
            <Box
              component="a"
              href={txEtherScan}
              sx={sx.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              Etherscan
            </Box>
            .
          </>
        )}
      </Typography>

      {/* <Spinner
        color={COLOR_CYAN}
        style={{ marginLeft: "auto", marginRight: "auto" }}
      /> */}
    </Box>
  );
};

export default PendingTx;
